import intelligenceSolutionsChart from "@/public/assets/img/intelligence-solutions-chart.svg"
import { DATA_PAGE_BASE_PATH } from "@/src/sb/constants/configs"
import Image from "next/legacy/image"

import { useAnalytics } from "../Analytics"
import Button from "../Button"

export const IntelligenceSolutionsBanner = ({
  onClose
}: {
  onClose?: () => void
}) => {
  const analytics = useAnalytics()

  return (
    <div className="mt-[93px]">
      <div className={"fixed bottom-0 z-10 bg-stears_white w-full shadow"}>
        <div className="flex min-h-[93px] items-center justify-center relative">
          {onClose ? (
            <button
              onClick={onClose}
              title={"Close banner"}
              className={
                "p-2 mr-2 absolute -top-3 right-0 inline-block bg-gray-300 rounded-full"
              }
            >
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.82426 0.175736C10.0586 0.410051 10.0586 0.78995 9.82426 1.02426L5.84875 5L9.82426 8.97574C10.0586 9.21005 10.0586 9.58995 9.82426 9.82426C9.58995 10.0586 9.21005 10.0586 8.97574 9.82426L5 5.84875L1.02426 9.82426C0.78995 10.0586 0.410051 10.0586 0.175736 9.82426C-0.0585786 9.58995 -0.0585786 9.21005 0.175736 8.97574L4.15125 5L0.175736 1.02426C-0.0585786 0.78995 -0.0585786 0.410051 0.175736 0.175736C0.410051 -0.0585786 0.78995 -0.0585786 1.02426 0.175736L5 4.15125L8.97574 0.175736C9.21005 -0.0585786 9.58995 -0.0585786 9.82426 0.175736Z"
                  fill="#121417"
                />
              </svg>
            </button>
          ) : null}

          <div className="w-full">
            <div className="tablet:px-5 w-full flex justify-between items-center px-16 h-full">
              <div className="pr-2 hidden sm:block flex justify-center items-center mr-6">
                <Image
                  src={intelligenceSolutionsChart}
                  alt={"Chart"}
                  width={60}
                  height={60}
                />
              </div>

              <div className="mobile:my-3 grow lg:text-2xl font-medium">
                <p className={"hidden lg:block"}>
                  Make better decisions with our suite of data solutions for
                  global organisations
                </p>
                <p className={"lg:hidden"}>
                  Make better decisions with our data solutions
                </p>
              </div>

              <div className={"ml-2 whitespace-nowrap"}>
                <Button
                  type="primary"
                  noWrap={true}
                  href={DATA_PAGE_BASE_PATH}
                  onClick={() => {
                    analytics?.clickIntelligenceSolutions()
                  }}
                >
                  Explore data
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
